import { queryOptions } from '@tanstack/react-query'
import accountingDocumentApi from 'api/accountingDocumentApi'
import _ from 'lodash'

export const queries = {
  base: {
    scope: ['handleInvoice', 'listReplacedInvoice'],
  },
  lists: () => ({
    ...queries.base,
    entity: 'adjusted_invoice',
  }),
  list: (params = {}) =>
    queryOptions({
      staleTime: 1000 * 30,
      queryKey: [queries.lists(), params],
      queryFn: ({ signal }) =>
        accountingDocumentApi.find(
          {
            ...params,
            invoiceType: 'adjust',
          },
          signal,
        ),
      select: (res) => {
        console.log('res:', res) // ✅ Log dữ liệu từ API
        return {
          total: _.get(res, 'totalItems', 0),
          rows: !res?.items
            ? []
            : _.map(res?.items, (item, idx) => ({
                ...item,
                id: idx + 1,
              })),
        }
      },
    }),
}
